import { createAction } from 'redux-actions';
import Types from './types';

export const getBlockedEnvironmentsRequest = createAction(
  Types.GET_BLOCKED_ENVIRONMENTS_REQUEST
);
export const getBlockedEnvironmentsFulfilled = createAction(
  Types.GET_BLOCKED_ENVIRONMENTS_FULFILLED
);
export const getBlockedEnvironmentsRejected = createAction(
  Types.GET_BLOCKED_ENVIRONMENTS_REJECTED
);

export const getEnvironmentHealthRequest = createAction(
  Types.GET_ENVIRONMENT_HEALTH_REQUEST
);
export const getEnvironmentHealthFulfilled = createAction(
  Types.GET_ENVIRONMENT_HEALTH_FULFILLED
);
export const getEnvironmentHealthRejected = createAction(
  Types.GET_ENVIRONMENT_HEALTH_REJECTED
);

export const getInstanceStatusRequest = createAction(
  Types.GET_INSTANCE_STATUS_REQUEST
);
export const getInstanceStatusFulfilled = createAction(
  Types.GET_INSTANCE_STATUS_FULFILLED
);
export const getInstanceStatusRejected = createAction(
  Types.GET_INSTANCE_STATUS_REJECTED
);

export const getEnvironmentAndCeleryQueueStatusRequest = createAction(
  Types.GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REQUEST
);
export const getEnvironmentAndCeleryQueueStatusFulfilled = createAction(
  Types.GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_FULFILLED
);
export const getEnvironmentAndCeleryQueueStatusRejected = createAction(
  Types.GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REJECTED
);

export const getEnvironmentsWithFailedZeroTrustRequest = createAction(
  Types.GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REQUEST
);
export const getEnvironmentsWithFailedZeroTrustFulfilled = createAction(
  Types.GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_FULFILLED
);
export const getEnvironmentsWithFailedZeroTrustRejected = createAction(
  Types.GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REJECTED
);

export const getSessionsHistoryMonitorGraphRequest = createAction(
  Types.GET_SESSIONS_HISTORY_MONITOR_GRAPH_REQUEST
);
export const getSessionsHistoryMonitorGraphFulfilled = createAction(
  Types.GET_SESSIONS_HISTORY_MONITOR_GRAPH_FULFILLED
);
export const getSessionsHistoryMonitorGraphRejected = createAction(
  Types.GET_SESSIONS_HISTORY_MONITOR_GRAPH_REJECTED
);

export const getClientsHistoryMonitorGraphRequest = createAction(
  Types.GET_CLIENTS_HISTORY_MONITOR_GRAPH_REQUEST
);
export const getClientsHistoryMonitorGraphFulfilled = createAction(
  Types.GET_CLIENTS_HISTORY_MONITOR_GRAPH_FULFILLED
);
export const getClientsHistoryMonitorGraphRejected = createAction(
  Types.GET_CLIENTS_HISTORY_MONITOR_GRAPH_REJECTED
);

export const getUsersHistoryMonitorGraphRequest = createAction(
  Types.GET_USERS_HISTORY_MONITOR_GRAPH_REQUEST
);
export const getUsersHistoryMonitorGraphFulfilled = createAction(
  Types.GET_USERS_HISTORY_MONITOR_GRAPH_FULFILLED
);
export const getUsersHistoryMonitorGraphRejected = createAction(
  Types.GET_USERS_HISTORY_MONITOR_GRAPH_REJECTED
);

export const getEnvironmentsCostMonitorGraphRequest = createAction(
  Types.GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST
);
export const getEnvironmentsCostMonitorGraphFulfilled = createAction(
  Types.GET_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED
);
export const getEnvironmentsCostMonitorGraphRejected = createAction(
  Types.GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED
);

export const getMonthlyEnvironmentsCostMonitorGraphRequest = createAction(
  Types.GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST
);
export const getMonthlyEnvironmentsCostMonitorGraphFulfilled = createAction(
  Types.GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED
);
export const getMonthlyEnvironmentsCostMonitorGraphRejected = createAction(
  Types.GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED
);

export const setPeriodFilterSessions = createAction(
  Types.SET_PERIOD_FILTER_SESSIONS
);
export const setPeriodFilterInstances = createAction(
  Types.SET_PERIOD_FILTER_INSTANCES
);

export const setPeriodClientHistoryFilter = createAction(
  Types.SET_PERIOD_CLIENT_HISTORY_FILTER
);
export const setPeriodFilterEnvironmentsCost = createAction(
  Types.SET_PERIOD_FILTER_ENVIRONMENTS_COST
);

export const getFlavorsCostRequest = createAction(
  Types.GET_FLAVORS_COST_MONITOR_REQUEST
);
export const getFlavorsCostFulfilled = createAction(
  Types.GET_FLAVORS_COST_MONITOR_FULFILLED
);
export const getFlavorsCostRejected = createAction(
  Types.GET_FLAVORS_COST_MONITOR_REJECTED
);
export const setFlavorsCostPeriodFilter = createAction(
  Types.SET_FLAVORS_COST_MONITOR_PERIOD_FILTER
);

export const getFlavorEnvironmentsRequest = createAction(
  Types.GET_FLAVOR_ENVIRONMENTS_REQUEST
);
export const getFlavorEnvironmentsFulfilled = createAction(
  Types.GET_FLAVOR_ENVIRONMENTS_FULFILLED
);
export const getFlavorEnvironmentsRejected = createAction(
  Types.GET_FLAVOR_ENVIRONMENTS_REJECTED
);

export const getInstancesWithSessionTimeoutRequest = createAction(
  Types.GET_INSTANCES_WITH_SESSION_TIMEOUT_REQUEST
);
export const getInstancesWithSessionTimeoutFulfilled = createAction(
  Types.GET_INSTANCES_WITH_SESSION_TIMEOUT_FULFILLED
);
export const getInstancesWithSessionTimeoutRejected = createAction(
  Types.GET_INSTANCES_WITH_SESSION_TIMEOUT_REJECTED
);
